import { type FormEvent } from 'react';
import type { CategorySelectPageViewModel } from './categorySelectPageViewModel';
import { useTranslation } from '../../../i18n/useTranslation';
import { CategoryRadio } from './CategoryRadio';
import { Offscreen } from 'src/lib/common/ui/Offscreen';
import { ArrowRight } from 'src/lib/assets/icons';
import styles from './CategorySelectForm.module.scss';

interface CategorySelectFormProps {
  viewModel: CategorySelectPageViewModel,
}

export function CategorySelectForm({ viewModel }: CategorySelectFormProps) {
  const { t } = useTranslation();
  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    viewModel.submit();
  };

  return (
    <article className={ styles.container }>

      <header className={ styles.header }>
        <h2 className={ styles.title }>
          { t('category_form_title') }
        </h2>
        <div className={ styles.subtitle }>
          { t('category_form_subtitle') }
        </div>
      </header>

      <form onSubmit={ onSubmit } className={ styles.form }>
        <fieldset className={ styles.fieldset }>
          <Offscreen as='legend'>
            { t('category_form_fieldset_label') }
          </Offscreen>
          <div className={ styles.categoryBlock }>
            <ul className={ styles.categoryBlockList }>
              {
                viewModel.options.map((category) => (
                  <li key={ category.id } className={ styles.categoryBlockListItem }>
                    <CategoryRadio
                      htmlId={ category.id }
                      label={ category.title }
                      image={ category.image }
                      name="category"
                      checked={ viewModel.isCategorySelected(category) }
                      onChange={ (checked) => viewModel.setSelectedCategory(category, checked) }
                    />
                  </li>
                ))
              }
            </ul>
          </div>
        </fieldset>

        <div className={ styles.formActions }>
          <button type="submit" className={ styles.submitButton }>
            <span>{ t('wizard_next_step') }</span>
            <ArrowRight />
          </button>
        </div>

      </form>
    </article>
  );
}
